import { render, staticRenderFns } from "./CidadeCadastro.vue?vue&type=template&id=5842fb04"
import script from "./CidadeCadastro.vue?vue&type=script&lang=js"
export * from "./CidadeCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports